import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styles from "./style.module.css";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import Table from "../../../../views/Table/Table.js";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import LocalConvenienceStoreRoundedIcon from "@material-ui/icons/LocalConvenienceStoreRounded";
import Tooltip from "@material-ui/core/Tooltip";
import DownloadProductInventory from "./DownloadProductInventory";

const ProductInventory = (props) => {
  console.log('Product Inventory');
  console.log(props);
  const [data, setData] = React.useState(false);
  console.log(props.value);
  React.useEffect(() => {
    axios({
      url: "/getProductPartListInWarehouse",
      method: "post",
      data: {
        productId: props.value.objectId._id,
        warehouseId: props.warehouseId,
      },
    })
      .then((res) => {
        if (res.data.data.length > 0) {
          setData(res.data.data);
        } else {
          setData("NO_DATA");
        }
      })
      .catch((err) => {
        console.log(err);
        // props.setAlert("Something went wrong try again")
        props.onClose();
      });
  }, []);

  let parts = [];
  console.log(data);
  data &&
    data != "NO_DATA" &&
    data.forEach((val) => {
      val.part &&
        parts.push([
          val.part.partName,
          val.part.parts_barcode,
          val.part.length,
          val.part.width,
          val.part.weight,
          val.part.height,
          val.part.status,
          val.quantity,
          <Tooltip title="Explore Part Inventory">
            <IconButton onClick={() => props.setPartInventoryModal(val.part)}>
              <LocalConvenienceStoreRoundedIcon />
            </IconButton>
          </Tooltip>,
        ]);
    });

  const isLoading = !data;
  const noData = data == "NO_DATA";
  const showData = !isLoading && !noData;
  const warehouse = props.warehouse;
  console.log(props.value);
  return (
    <Dialog
      open={props.value}
      onClose={props.onClose}
      scroll={"paper"}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <div className={styles.container}>
        <div className={styles.containerContent}>
          <div className={styles.header}>
            <h1>Warehosue Product Inventory</h1>
            <div style={{ justifyContent: "flex-end" }}>
              {" "}
              {showData && (
                <DownloadProductInventory
                  details={parts}
                  name={warehouse}
                  product={props.value}
                  quantity={props.value}
                />
              )}
              <IconButton onClick={props.onClose}>
                <CloseRoundedIcon />
              </IconButton>
            </div>
          </div>
          {noData && (
            <div className={styles.loader}>
              <h4>Warehouse does not have any Product </h4>
            </div>
          )}

          {showData && (
            <div className={styles.content}>
              <h2>Warehouse Detail</h2>
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Name",
                  "Bar Code",
                  "Address",
                  "Location",
                  "Contact Number",
                ]}
                tableData={[
                  [
                    warehouse ? warehouse.name : "Nan",
                    warehouse ? warehouse.warehouse_barcode : "Nan",
                    warehouse ? warehouse.address : "Nan",
                    warehouse ? warehouse.warehouseLocation : "Nan",
                    warehouse ? warehouse.contactNum : "Nan",
                  ],
                ]}
              />

              <h2>Product Details</h2>

              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Product Name",
                  "Product Code",
                  "Category",
                  "Warehouse Stock",
                  "Booked Stock",
                  "Balanced Stock",
                ]}
                tableData={[
                  [
                    props.value.objectId.productName,
                    props.value.objectId.product_barcode,
                    props.value.objectId.categories
                      ? props.value.objectId.categories.categoryName
                      : "Nan",
                    props.value.warehouseStock,
                    props.value.bookedStock,
                    props.value.balanceStock,
                    // props.value.quantity,
                  ],
                ]}
              />

              <h2 style={{ textAlign: "left" }}>Part Details</h2>

              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Part Name",
                  "Part Code",
                  "Length",
                  "Width",
                  "Weight",
                  "Height",
                  "Status",
                  "Quantity",
                  "Action",
                ]}
                tableData={parts}
              />
            </div>
          )}

          {isLoading && (
            <div className={styles.loader}>
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default ProductInventory;
